module.exports = __webpack_public_path__ + "fonts/font.3d48ae1.woff";